import { Link } from 'react-router-dom';
import { Button } from '../components';

export default function NotFoundPage() {
  return (
    <div className="flex h-screen items-center justify-center bg-paper">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-ink">404</h1>
        <p className="mt-4 text-2xl font-semibold text-ink-2">Page Not Found</p>
        <p className="mt-2 text-ink-3">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="mt-8">
          <Link to="/dashboard">
            <Button>Go to Dashboard</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
